/** Catálogo de jogos (textos alinhados ao app — pt.ts `games.*`). */

export const PLAY_STORE_SINALARIO =
  "https://play.google.com/store/apps/details?id=com.bilingua.sinalario";

export type WebGameItem = {
  id: string;
  title: string;
  description: string;
  color: string;
  difficulty: string;
  estimatedTime: string;
};

export const GAMES_CATALOG: WebGameItem[] = [
  {
    id: "flashcards",
    title: "Jogo da Memória com Sinais",
    description: "Encontre os pares de palavras e seus sinais em vídeo",
    color: "#F59E0B",
    difficulty: "Fácil",
    estimatedTime: "5 min",
  },
  {
    id: "flashcardsImages",
    title: "Jogo da Memória com Imagens",
    description: "Encontre os pares combinando as imagens",
    color: "#EAB308",
    difficulty: "Fácil",
    estimatedTime: "5 min",
  },
  {
    id: "wordCompletion",
    title: "Complete a Palavra",
    description: "Preencha as letras faltantes",
    color: "#5F33E1",
    difficulty: "Médio",
    estimatedTime: "8 min",
  },
  {
    id: "wordMatching",
    title: "Ligar Palavras",
    description: "Conecte palavras aos seus sinais",
    color: "#10B981",
    difficulty: "Médio",
    estimatedTime: "10 min",
  },
  {
    id: "completeSign",
    title: "Complete o Sinal",
    description: "Veja o sinal e escolha a palavra correta",
    color: "#06B6D4",
    difficulty: "Médio",
    estimatedTime: "6 min",
  },
  {
    id: "wordBuilder",
    title: "Montar Palavras",
    description: "Arraste as letras para formar palavras",
    color: "#EC4899",
    difficulty: "Difícil",
    estimatedTime: "12 min",
  },
  {
    id: "connectDots",
    title: "Ligar os Pontos",
    description: "Conecte os pontos na ordem correta",
    color: "#8B5CF6",
    difficulty: "Fácil",
    estimatedTime: "6 min",
  },
  {
    id: "signBuilder",
    title: "Construtor de Sinais",
    description: "Monte o sinal com os parâmetros corretos",
    color: "#F97316",
    difficulty: "Difícil",
    estimatedTime: "15 min",
  },
  {
    id: "signPuzzle",
    title: "Quebra-cabeça do Sinal",
    description: "Monte a imagem do sinal trocando as peças",
    color: "#14B8A6",
    difficulty: "Fácil",
    estimatedTime: "5 min",
  },
  {
    id: "dactylologyPuzzle",
    title: "Quebra-cabeça Datilologia",
    description: "Monte as letras do alfabeto manual na ordem certa",
    color: "#4614BB",
    difficulty: "Médio",
    estimatedTime: "8 min",
  },
];
